import { makeObservable, action, observable } from 'mobx';
import MkMessNotifRequests from "Utils/Requests/MkMessNotifRequests";
import AppStore from 'Stores/AppStore';
import { ShowAlert } from "Utils/CommonFunctions";

class MkMessageListStore {
    messagesLoading;
    tableStore;
    /** @type {number[]} */
    selectedMessages;

    constructor() {
        makeObservable(this, {
            messagesLoading: observable,
            selectedMessages: observable
        });

        this.messagesLoading = false;
        this.selectedMessages = [];
    }

    SetTableStore(store) {
        this.tableStore = store;
    }

    SelectCurrentPageOfMessages = action((state) => {
        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i].selected && !state)
                this.selectedMessages.splice(this.selectedMessages.indexOf(this.messages[i].id), 1);
            else if (!this.messages[i].selected && state)
                this.selectedMessages.push(this.messages[i].id);

            this.messages[i].selected = state;
        }

        this.allMessagesOnPageAreSelected = state;
    });

    RemoveSelectedMessages = action(() => {
        this.messagesLoading = true;

        MkMessNotifRequests.DeleteMessages(this.selectedMessages)
            .then(action(() => {
                ShowAlert('success', `Успешно удалено сообщений: ${this.selectedMessages.length}`);
                this.selectedMessages = [];
                this.GetMessages();
            }));
    });

    SelectItemInMessageList = action((id, state) => {
        let selectedCount = 0;

        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i].id === id) {
                if (state) {
                    this.selectedMessages.push(id)
                } else {
                    for (let i = 0; i < this.selectedMessages.length; i++) {
                        if (this.selectedMessages[i] === id) {
                            this.selectedMessages.splice(i, 1);
                            break;
                        }
                    }
                }

                this.messages[i].selected = state;
            }

            if (this.messages[i].selected)
                selectedCount++;
        }

        this.allMessagesOnPageAreSelected = selectedCount === this.messages.length;
    });

    GetMessages = action(pageToSet => {
        if (pageToSet == null)
            pageToSet = 1;

        let { elementsPerPage } = this.tableStore.paginationInfo;

        this.messagesLoading = true;

        MkMessNotifRequests.GetMessages((pageToSet - 1) * elementsPerPage, elementsPerPage)
            .then(action(values => {
                if (!this.tableStore.HandlePagination(this.SetPageData, values.recordsFiltered, pageToSet, page => this.GetMessages(page)))
                    return;

                this.messagesLoading = false;
                let selectedCount = 0;
                this.messages = values.data.map(item => {
                    item.selected = this.selectedMessages.indexOf(item.id) >= 0;

                    if (item.selected)
                        selectedCount++;

                    return item;
                });

                this.allMessagesOnPageAreSelected = selectedCount === this.messages.length;

                this.tableStore.data = this.messages;
            }));
    });

    SetPageData(pageToSet) {
        window.history.pushState(null, `Информирование пользователей. Страница ${pageToSet}`, `./mkMessageList?page=${pageToSet}`);

        AppStore.SetLastPageInfo({
            pageTitle: 'mkMessageList',
            params: {
                page: `${pageToSet}`
            }
        });
    }
}

export default new MkMessageListStore();